import { Injectable } from '@angular/core';
import { ActivityComponentUIState } from './activity-component.uistate';
import { ActivityComponentRepository } from './activity-component.repository';
import { BizComponentEntity } from '../../domain/entities/biz-component.entity';
import { GspComponent } from '@gsp-cmp/common-component';
import { MessagerService } from '@farris/ui-messager';
import { WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';

@Injectable()

export class ActivityComponentViewModel {
    
    constructor(
        private uistate: ActivityComponentUIState,
        private repository: ActivityComponentRepository,
        private messager: MessagerService,
        private localePipe: WfLocalePipe
    ) { }

    deleteRow() {
        if (this.uistate.curComponent) {
            if (this.uistate.curComponent.executionTime === 'LOADDATA') {
                this.messager.info(this.localePipe.transform('component.activityComponent.deleteNotAllowed'));
            } else {
                this.repository.removeComponent(this.uistate.curComponent.id);
            }
        } else {
            return;
        }
    }
    componentSelect(cpt: GspComponent) {
        if (cpt) {
            this.repository.addComponent(cpt);
        }
    }

    loadComponents(flowFormId: string, bizActId: string) {
        this.repository.loadComponents(flowFormId, bizActId);
    }
}
